import { render, staticRenderFns } from "./ClientPutEdit.vue?vue&type=template&id=98179e78"
import script from "./ClientPutEdit.vue?vue&type=script&lang=js"
export * from "./ClientPutEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports